"use strict";

module.exports = function () {
  this.selectedRows = this.data;
  return this.selectedRows;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/methods/select-all-rows.js
// module id = 927
// module chunks = 0